import React from "react";
import PolicyPage from "./PolicyPage";

const sections = [
  {
    title: "Content covered",
    paragraphs: ["This policy covers photographs, written descriptions, documents and other material a customer sends privately to support an order, delivery, accessibility, intellectual-property or product-safety request. The material is connected to the stated case and is not treated as permission for public promotion."],
  },
  {
    title: "What to send",
    paragraphs: ["Provide only material needed to show the concern: for example the affected item, parcel, label, order correspondence or screen barrier. Conceal unrelated personal details and never include payment-card credentials. Medical records and identity documents should not be sent unless customer service specifically explains why limited information is required for a lawful step."],
  },
  {
    title: "Authority and authenticity",
    paragraphs: ["The sender must have the right to share the material and should describe edits that could affect its evidential meaning. Content must not impersonate another person, include a malicious file, unlawfully expose someone else's personal data, or knowingly misstate the product or event."],
  },
  {
    title: "Case-use permission",
    paragraphs: ["By submitting evidence, the sender permits it to be stored, copied internally and shared with service providers or advisers only to the extent needed to investigate and resolve that case, protect the service or meet a binding legal requirement. Ownership is not transferred by this limited permission."],
  },
  {
    title: "Privacy and retention",
    paragraphs: ["Access is limited according to the case purpose. The material is retained with the related support record while needed for transaction, safety, fraud, dispute or compulsory-record purposes and is then erased or de-identified where practicable. A person shown in an image may raise a privacy concern through Consumer Data Rights."],
    links: [["Consumer Data Rights", "/data-rights"]],
  },
  {
    title: "Challenge or removal request",
    paragraphs: ["A sender can identify content believed to be inaccurate, unnecessary or used beyond the case purpose. The review will correct, restrict or erase it where the facts and applicable obligations support that outcome. The request does not require surrender of another mandatory right."],
  },
];

export default function CustomerContent() {
  return <PolicyPage title="Support Evidence & Customer Content" intro="Rules for private material customers send to document an order, product or access issue." sections={sections} related={[["Privacy Policy", "/privacy"], ["Product Safety & Care", "/product-safety"], ["Intellectual Property", "/intellectual-property"]]} />;
}
